export enum CompareDatesEnum {
  BEFORE = -1,
  AFTER = 1,
  EQUAL = 0,
}
